export const SEARCH_MANUFACTURER_TAB_DATA = 'SEARCH_MANUFACTURER_TAB_DATA';
export const MAINTAIN_MANUFACTURER_TAB_DATA = 'MAINTAIN_MANUFACTURER_TAB_DATA';
export const GET_ALL_MANUFACTURERS = 'GET_ALL_MANUFACTURERS';
export const GET_ALL_MFG_LABELERS = 'GET_ALL_MFG_LABELERS';
export const GET_LABELER_USING_MANUFACTURES = 'GET_LABELER_USING_MANUFACTURES';
export const GET_ALL_MANUFACTURER_SEARCH_BY_G =
  'GET_ALL_MANUFACTURER_SEARCH_BY_G';
export const GET_ALL_MANUFACTURER_SEARCH_BY_C =
  'GET_ALL_MANUFACTURER_SEARCH_BY_C';
export const GET_ALL_MFG_CONTRACTS = 'GET_ALL_MFG_CONTRACTS';
export const SELECT_DATA_MANUFACTURER = 'SELECT_DATA_MANUFACTURER';
export const SAVE_OR_UPDATE = 'SAVE_OR_UPDATE';
export const MAINTAIN_LABELER_DATA_ACTION_TYPES =
  'MAINTAIN_LABELER_DATA_ACTION_TYPES';
export const MAINTAIN_LABELER_FILTER_DATA = 'MAINTAIN_LABELER_FILTER_DATA';
export const MAINTAIN_BANKRUPTCY_DATA_ACTION_TYPES =
  'MAINTAIN_BANKRUPTCY_DATA_ACTION_TYPES';
export const MAINTAIN_BANKRUPTCY_FILTER_DATA =
  'MAINTAIN_BANKRUPTCY_FILTER_DATA';
export const GET_ALL_MANUFACTURER_DETAILS_ACTION_TYPE =
  'GET_ALL_MANUFACTURER_DETAILS_ACTION_TYPE';
export const SEARCH_LABELER_POPUP_DATA_ACTION_TYPES =
  'SEARCH_LABELER_POPUP_DATA_ACTION_TYPES';
export const GET_COMMON_MANUFACTURER_DROPDOWN =
  'GET_COMMON_MANUFACTURER_DROPDOWN';
export const MAINTAIN_GROUP_CONTACT_ACTION_TYPES =
  'MAINTAIN_GROUP_CONTACT_ACTION_TYPES';
export const GET_CONTACT_TYPE = 'GET_CONTACT_TYPE';
export const GET_EXISTING_CONTACT_DETAILS_MFG =
  'GET_EXISTING_CONTACT_DETAILS_MFG';
export const GET_CONTACT_DETAILS = 'GET_CONTACT_DETAILS';
export const UPDATE_CONTACT_DETAILS = 'UPDATE_CONTACT_DETAILS';
export const NAVIGATION_LISTENER_ACTION_TYPES =
  'NAVIGATION_LISTENER_ACTION_TYPES';
export const ERROR_POPUP_ACTION_TYPES = 'ERROR_POPUP_ACTION_TYPES';
export const GET_GENERAL_SYSTEM_PARAMETER = 'GET_GENERAL_SYSTEM_PARAMETER';
export const CONTRACT_USING_CONTACT_TYPE = ' CONTRACT_USING_CONTACT_TYPE';
export const COPY_CONTACT_GET_CLIENT_CODE_VALUES =
  'COPY_CONTACT_GET_CLIENT_CODE_VALUES';
export const GET_ALL_CLIENT_GROUP_FOR_COPY_CONTACT =
  'GET_ALL_CLIENT_GROUP_FOR_COPY_CONTACT';
export const GET_ALL_CLIENT_GROUP_PLAN_FOR_COPY_CONTACT =
  'GET_ALL_CLIENT_GROUP_PLAN_FOR_COPY_CONTACT';
export const GET_ALL_CLIENT_FOR_COPY_CONTACT =
  'GET_ALL_CLIENT_FOR_COPY_CONTACT';
export const GET_ALL_CONTRACT_FOR_COPY_CONTACT =
  'GET_ALL_CONTRACT_FOR_COPY_CONTACT';
export const GET_ALL_PROVIDER_FOR_COPY_CONTACT =
  'GET_ALL_PROVIDER_FOR_COPY_CONTACT';
export const GET_EXISTING_CONTACT_DETAILS_FOR_COPY_CONTACT =
  'GET_EXISTING_CONTACT_DETAILS_FOR_COPY_CONTACT';
export const ADD_PROVIDER_API_CANCEL_SOURCE =
  'ADD_PROVIDER_API_CANCEL_SOURCE';
export const CLEAR_PROVIDER_API_CANCEL_SOURCES =
  'CLEAR_PROVIDER_API_CANCEL_SOURCES';